module.exports = __webpack_public_path__ + "static/img/icon_wechatmini_products.8a03453.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/hsbpc/views/welcome/components/img/icon_wechatmini_products.png
// module id = De4h
// module chunks = 1